import type { FC } from 'react';
import Modal from './Modal';
import Button, { type ButtonVariant } from './Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: Extract<ButtonVariant, 'primary' | 'danger'>;
  loading?: boolean;
};

const ConfirmModal: FC<Props> = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm action',
  description = 'Are you sure you want to continue?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  loading = false
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      // description={description}
      size='sm'
      footer={
        <>
          <Button variant="secondary" onClick={onClose} type="button" disabled={loading}>
            {cancelText}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm} type="button" loading={loading}>
            {confirmText}
          </Button>
        </>
      }
    >
      <div className="text-sm text-gray-700">{description}</div>
    </Modal>
  );
};

export default ConfirmModal;
